export const CheckboxEventType = {
  Toggle: 'toggle',
  Click: 'click',
};

export const CheckboxProperty = {
  Value: 'value',
  Label: 'label',
  Disabled: 'disabled',
  Id: 'id',
  IsChecked: 'isChecked',
  ClassName: 'className',
  CheckboxIconSize: 'checkboxIconSize',
  Type: 'type',
  Size: 'size',
};
